// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var $dot$dot = require("..");

function create(prim, prim$1, prim$2, prim$3) {
  return $dot$dot.createLink(prim, prim$1, prim$2, prim$3);
}

function getId(prim) {
  return $dot$dot.getLinkId(prim);
}

function getInputNodeId(prim) {
  return $dot$dot.getLinkInputNodeId(prim);
}

function getOutputNodeId(prim) {
  return $dot$dot.getLinkOutputNodeId(prim);
}

function getInputPinKey(prim) {
  return $dot$dot.getLinkInputPinKey(prim);
}

function getOutputPinKey(prim) {
  return $dot$dot.getLinkOutputPinKey(prim);
}

function setInputPinKey(prim, prim$1) {
  return $dot$dot.setLinkInputPinKey(prim, prim$1);
}

function setOutputPinKey(prim, prim$1) {
  return $dot$dot.setLinkOutputPinKey(prim, prim$1);
}

function inputNodeIdEquals(prim, prim$1) {
  return $dot$dot.isLinkInputNodeIdEquals(prim, prim$1);
}

function outputNodeIdEquals(prim, prim$1) {
  return $dot$dot.isLinkOutputNodeIdEquals(prim, prim$1);
}

function inputPinKeyEquals(prim, prim$1) {
  return $dot$dot.isLinkInputPinKeyEquals(prim, prim$1);
}

function outputPinKeyEquals(prim, prim$1) {
  return $dot$dot.isLinkOutputPinKeyEquals(prim, prim$1);
}

exports.create = create;
exports.getId = getId;
exports.getInputNodeId = getInputNodeId;
exports.getOutputNodeId = getOutputNodeId;
exports.getInputPinKey = getInputPinKey;
exports.getOutputPinKey = getOutputPinKey;
exports.setInputPinKey = setInputPinKey;
exports.setOutputPinKey = setOutputPinKey;
exports.inputNodeIdEquals = inputNodeIdEquals;
exports.outputNodeIdEquals = outputNodeIdEquals;
exports.inputPinKeyEquals = inputPinKeyEquals;
exports.outputPinKeyEquals = outputPinKeyEquals;
/* .. Not a pure module */
